import { render, staticRenderFns } from "./thirdparties-card.vue?vue&type=template&id=59945269&scoped=true&"
import script from "./thirdparties-card.vue?vue&type=script&lang=js&"
export * from "./thirdparties-card.vue?vue&type=script&lang=js&"
import style0 from "./thirdparties-card.vue?vue&type=style&index=0&id=59945269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59945269",
  null
  
)

export default component.exports